var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page--padding shop"},[_c('section',{staticClass:"section--page"},[_c('category-list',{attrs:{"items":_vm.categories}})],1),_c('section',{staticClass:"section--image shop__bg"})])}
var staticRenderFns = []

export { render, staticRenderFns }